import { Component, EventEmitter, OnInit, OnDestroy, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../services/navigation.helper";

@Component({
  selector: "main-screen",
  templateUrl: "./main-screen.component.html",
  styleUrls: ["./main-screen.component.css"],
})
export class MainScreenComponent implements OnInit, OnDestroy {
  @Output() screenType = new EventEmitter<string>();
  screenSize: string = "desktop";

  private intervalId: any;
  private resizeHandler = () => this.updateScreenSize();
  private lastScreenSize: string | null = null;

  constructor(private router: Router,
    private navigate : NavigationHelper
  ) { }

  ngOnInit(): void {
    this.updateScreenSize();
    window.addEventListener("resize", this.resizeHandler);
    this.intervalId = setInterval(() => this.updateScreenSize(), 300);
  }

  ngOnDestroy(): void {
    if (this.intervalId) clearInterval(this.intervalId);
    window.removeEventListener("resize", this.resizeHandler);
  }

private updateScreenSize() {
  const zoomAwareWidth = window.innerWidth;
  const zoom = window.devicePixelRatio;
  let effectiveWidth = zoomAwareWidth;
  if (zoom > 1.33) effectiveWidth = zoomAwareWidth / zoom;

  let newSize: string;
  if (effectiveWidth <= 850) newSize = "mobile";
  else if (effectiveWidth <= 1300) newSize = "tablet";
  else newSize = "desktop";

  this.screenSize = newSize;
  this.screenType.emit(this.screenSize);
  this.lastScreenSize = newSize;
}



}
